import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { startAuthentication } from '@simplewebauthn/browser';
import Swal from 'sweetalert2';

const AdminCancelReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const authFetch = async (url, options = {}) => {
    return fetch(url, options);
  };

  const handleAction = async (action) => {
    try {
      setLoading(true);
      setError('');

      // 1. Get Authentication Challenge from Server
      const challengeRes = await authFetch('/api/passkey/generate-auth-options');
      if (!challengeRes.ok) {
        throw new Error('Failed to generate biometric challenge. Have you registered your device?');
      }
      const authOptions = await challengeRes.json();

      // 2. Trigger Face ID / Touch ID
      let asseResp;
      try {
        asseResp = await startAuthentication(authOptions);
      } catch (err) {
        throw new Error('Biometric authentication cancelled or failed.');
      }

      // 3. Send signature and action to server
      const endpoint = action === 'approve' 
        ? `/api/subscription/admin/approve-cancel/${id}`
        : `/api/subscription/admin/reject-cancel/${id}`;
        
      const verifyRes = await authFetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(asseResp)
      });

      if (!verifyRes.ok) {
        const errData = await verifyRes.json();
        throw new Error(errData.message || `Failed to ${action} cancellation`);
      }

      Swal.fire(
        'Success!',
        `Cancellation request successfully ${action === 'approve' ? 'approved and refunded' : 'rejected'}.`,
        'success'
      ).then(() => {
        navigate('/'); // go to dashboard
      });

    } catch (err) {
      setError(err.message);
      Swal.fire('Error', err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card className="shadow-lg border-0" style={{ width: '100%', maxWidth: '500px', borderRadius: '15px' }}>
        <Card.Body className="p-5 text-center">
          <div className="mb-4">
            <div style={{ width: '60px', height: '60px', borderRadius: '30px', backgroundColor: '#ffebee', color: '#d32f2f', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto' }}>
              <i className="fas fa-shield-alt fa-2x"></i>
            </div>
          </div>
          
          <h3 className="fw-bold mb-3">Admin Review</h3>
          <p className="text-muted mb-4">
            You are reviewing Cancellation Request <strong>#{id}</strong>.
            <br />
            <small>Biometric authentication is required to proceed.</small>
          </p>

          {error && <Alert variant="danger">{error}</Alert>}

          <div className="d-grid gap-3">
            <Button 
              variant="danger" 
              size="lg" 
              onClick={() => handleAction('approve')}
              disabled={loading}
              style={{ padding: '12px', fontWeight: 'bold' }}
            >
              {loading ? <Spinner size="sm" /> : 'Approve & Refund'}
            </Button>
            
            <Button 
              variant="outline-secondary" 
              size="lg" 
              onClick={() => handleAction('reject')}
              disabled={loading}
              style={{ padding: '12px', fontWeight: 'bold' }}
            >
              {loading ? <Spinner size="sm" /> : 'Reject Request'}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AdminCancelReview;
